import { combineReducers } from 'redux';
import * as constants from './actions';

const data = (state = {}, action) => {
  switch (action.type) {
    case constants.FETCH_COUNTRY_SND_MAP_BY_ID_SUCCESS:
    case constants.FETCH_SND_REGION_MAP_BY_ID_SUCCESS:
    case constants.FETCH_SND_AREA_MAP_BY_ID_SUCCESS:
    case constants.FETCH_SND_TERRITORY_MAP_BY_ID_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

const distributionHouseSummary = (state = {}, action) => {
  switch (action.type) {
    case constants.FETCH_DISTRIBUTION_HOUSE_SUMMARY_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

const highBalanceAgentSummary = (state = {}, action) => {
  switch (action.type) {
    case constants.FETCH_HIGH_BALANCE_AGENT_SUMMARY_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

const dhStockBalanceLiftingSummary = (state = {}, action) => {
  switch (action.type) {
    case constants.FETCH_DH_STOCK_BALANCE_LIFTING_SUMMARY_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

const dhStockProgressSummary = (state = {}, action) => {
  switch (action.type) {
    case constants.FETCH_DH_STOCK_PROGRESS_SUMMARY_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

const dhStockBalanceAgentSummary = (state = {}, action) => {
  switch (action.type) {
    case constants.FETCH_DH_STOCK_BALANCE_AGENT_SUMMARY_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

const agentWithTransactionSummary = (state = {}, action) => {
  switch (action.type) {
    case constants.FETCH_AGENT_WITH_TRANSACTION_SUMMARY_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

const leadingAgentSummary = (state = {}, action) => {
  switch (action.type) {
    case constants.FETCH_LEADING_AGENT_SUMMARY_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

const leadingAgentTpvSummary = (state = {}, action) => {
  switch (action.type) {
    case constants.FETCH_LEADING_AGENT_TPV_SUMMARY_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

const leadingAgentCategorySummary = (state = {}, action) => {
  switch (action.type) {
    case constants.FETCH_LEADING_AGENT_CATEGORY_SUMMARY_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

const milkingAgentSummary = (state = {}, action) => {
  switch (action.type) {
    case constants.FETCH_MILKING_AGENT_SUMMARY_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

const activeAgentSummary = (state = {}, action) => {
  switch (action.type) {
    case constants.FETCH_ACTIVE_AGENT_SUMMARY_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

const activeAgentWithoutDisbursementSummary = (state = {}, action) => {
  switch (action.type) {
    case constants.FETCH_ACTIVE_AGENT_WITHOUT_DISBURSEMENT_SUMMARY_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

const activeAgentPartnerPaymentOnlySummary = (state = {}, action) => {
  switch (action.type) {
    case constants.FETCH_ACTIVE_AGENT_PARTNER_PAYMENT_SUMMARY_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

const activeDistributionHouses = (state = [], action) => {
  switch (action.type) {
    case constants.FETCH_TERRITORY_DISTRIBUTION_HOUSES_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

const highBalanceAgents = (state = [], action) => {
  switch (action.type) {
    case constants.FETCH_TERRITORY_HIGH_BALANCE_AGENTS_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

const dhStockBalanceLiftings = (state = [], action) => {
  switch (action.type) {
    case constants.FETCH_TERRITORY_DH_STOCK_BALANCE_LIFTINGS_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

const dhStockProgress = (state = [], action) => {
  switch (action.type) {
    case constants.FETCH_TERRITORY_DH_STOCK_PROGRESS_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

const dhStockBalanceAgents = (state = [], action) => {
  switch (action.type) {
    case constants.FETCH_TERRITORY_DH_STOCK_BALANCE_AGENT_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

const activeAgents = (state = [], action) => {
  switch (action.type) {
    case constants.FETCH_TERRITORY_ACTIVE_AGENTS_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

const activeAgentsWithoutDisbursement = (state = [], action) => {
  switch (action.type) {
    case constants.FETCH_TERRITORY_ACTIVE_AGENTS_WITHOUT_DISBURSEMENT_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

const activeAgentsPartnerPayment = (state = [], action) => {
  switch (action.type) {
    case constants.FETCH_TERRITORY_ACTIVE_AGENTS_PARTNER_PAYMENT_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

const agentsWithTransaction = (state = [], action) => {
  switch (action.type) {
    case constants.FETCH_TERRITORY_AGENTS_WITH_TRANSACTION_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

const leadingAgents = (state = [], action) => {
  switch (action.type) {
    case constants.FETCH_TERRITORY_LEADING_AGENTS_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

const leadingAgentsTpv = (state = [], action) => {
  switch (action.type) {
    case constants.FETCH_TERRITORY_LEADING_AGENTS_TPV_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

const leadingGoldAgents = (state = [], action) => {
  switch (action.type) {
    case constants.FETCH_TERRITORY_LEADING_GOLD_AGENTS_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

const leadingSilverAgents = (state = [], action) => {
  switch (action.type) {
    case constants.FETCH_TERRITORY_LEADING_SILVER_AGENTS_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

const leadingBronzeAgents = (state = [], action) => {
  switch (action.type) {
    case constants.FETCH_TERRITORY_LEADING_BRONZE_AGENTS_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

const milkingAgents = (state = [], action) => {
  switch (action.type) {
    case constants.FETCH_TERRITORY_MILKING_AGENTS_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

export default combineReducers({
  data,
  distributionHouseSummary,
  highBalanceAgentSummary,
  dhStockBalanceLiftingSummary,
  dhStockProgressSummary,
  dhStockBalanceAgentSummary,
  agentWithTransactionSummary,
  leadingAgentSummary,
  leadingAgentTpvSummary,
  leadingAgentCategorySummary,
  milkingAgentSummary,
  activeAgentSummary,
  activeAgentWithoutDisbursementSummary,
  activeAgentPartnerPaymentOnlySummary,
  activeDistributionHouses,
  highBalanceAgents,
  dhStockBalanceLiftings,
  dhStockProgress,
  dhStockBalanceAgents,
  activeAgents,
  activeAgentsWithoutDisbursement,
  activeAgentsPartnerPayment,
  agentsWithTransaction,
  leadingAgents,
  leadingAgentsTpv,
  leadingGoldAgents,
  leadingSilverAgents,
  leadingBronzeAgents,
  milkingAgents
});

export const getCkuMapData = state => {
  return state.user.snd.map;
};

export const getActiveDistributionHouses = state => {
  return state.user.snd.map.activeDistributionHouses;
};

export const getHighBalanceAgents = state => {
  return state.user.snd.map.highBalanceAgents;
};

export const getDhStockBalanceLiftings = state => {
  return state.user.snd.map.dhStockBalanceLiftings;
};

export const getDhStockProgress = state => {
  return state.user.snd.map.dhStockProgress;
};

export const getDhStockBalanceAgents = state => {
  return state.user.snd.map.dhStockBalanceAgents;
};

export const getActiveAgents = state => {
  return state.user.snd.map.activeAgents;
};

export const getActiveAgentsWithoutDisbursement = state => {
  return state.user.snd.map.activeAgentsWithoutDisbursement;
};

export const getActiveAgentsPartnerPayment = state => {
  return state.user.snd.map.activeAgentsPartnerPayment;
};

export const getAgentsWithTransaction = state => {
  return state.user.snd.map.agentsWithTransaction;
};

export const getLeadingAgents = state => {
  return state.user.snd.map.leadingAgents;
};

export const getLeadingAgentsTpv = state => {
  return state.user.snd.map.leadingAgentsTpv;
};

export const getLeadingGoldAgents = state => {
  return state.user.snd.map.leadingGoldAgents;
};

export const getLeadingSilverAgents = state => {
  return state.user.snd.map.leadingSilverAgents;
};

export const getLeadingBronzeAgents = state => {
  return state.user.snd.map.leadingBronzeAgents;
};

export const getMilkingAgents = state => {
  return state.user.snd.map.milkingAgents;
};
